var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"no-body":""}},[_c('v-table',{ref:"table",attrs:{"buttons":_vm.buttons,"name":"agreement","fields":_vm.fields,"items-provider":_vm.provider,"search":"","pagination":"server"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }